import { SVG, SVGProps } from './svg'

export function IconToolText(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path d="M8.72 21.1c.39 0 .58-.15.72-.55l.94-2.6h4.33l.94 2.6c.14.4.33.55.71.55.39 0 .64-.24.64-.6 0-.13-.02-.24-.08-.4l-3.44-9.14c-.17-.46-.47-.68-.94-.68-.45 0-.76.22-.92.67L8.2 20.11c-.06.16-.08.27-.08.4 0 .36.23.59.61.59zm2.02-4.25l1.78-4.93h.04l1.78 4.93h-3.6zm10.3 4.32c1.12 0 2.18-.62 2.63-1.57h.03v.97c0 .36.25.6.6.6.34 0 .6-.24.6-.63v-4.89c0-1.6-1.18-2.63-3.04-2.63-1.38 0-2.53.61-2.94 1.56-.08.18-.14.36-.14.5 0 .33.24.54.55.54.23 0 .4-.08.52-.29a2 2 0 011.98-1.24c1.14 0 1.83.63 1.83 1.66v.63l-2.37.13c-1.85.1-2.89.96-2.89 2.32 0 1.4 1.08 2.34 2.63 2.34zm.3-1.02c-1 0-1.67-.54-1.67-1.35 0-.77.62-1.3 1.77-1.37l2.22-.14v.78c0 1.16-1.04 2.08-2.33 2.08z" />
    </SVG>
  )
}
